import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See {@link SvgIcon} base class for all `propTypes`.
 *
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Function component rendering the vehicle icon.
 *
 * @param {Object} [props] - The icon component properties.
 * @returns {React.ReactElement} A SVG element.
 *
 * @see SvgIcon
 * @example
 * <VehicleIcon width={12} />
 */
const VehicleIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M41.1,20.15l-1.23-1.23a4.77,4.77,0,0,1-1-1.57l-2.3-6.89a5.62,5.62,0,
            0,0-5-3.61H16.4a5.62,5.62,0,0,0-5,3.61L9.1,17.35a4.77,4.77,0,0,1-1,1.57L6.9,
            20.15A9.27,9.27,0,0,0,5,25.85v11.4a1.9,1.9,0,0,0,1.9,1.9h3.8a1.9,1.9,0,0,0,
            1.9-1.9v-1.9H35.4v1.9a1.9,1.9,0,0,0,1.9,1.9h3.8a1.9,1.9,0,0,0,1.9-1.9V25.85A9.27,
            9.27,0,0,0,41.1,20.15ZM9.75,29.65A2.85,2.85,0,1,1,12.6,26.8,2.85,2.85,0,0,1,9.75,
            29.65Zm20.9,1.9H17.35a1,1,0,1,1,0-1.9h13.3A1,1,0,1,1,30.65,31.55Zm-18.9-13.3a0.64,
            0.64,0,0,1-.65-0.9l2.1-6.29a3.76,3.76,0,0,1,3.2-2.31H31.6a3.76,3.76,0,0,1,3.2,
            2.31l2.1,6.29a0.64,0.64,0,0,1-.65.9H11.75Zm26.5,11.4A2.85,2.85,0,1,1,41.1,26.8,
            2.85,2.85,0,0,1,38.25,29.65Z`}
        />
    </SvgIcon>
)

VehicleIcon.defaultProps = defaultProps

export { VehicleIcon }
